module.exports = __webpack_public_path__ + "img/949f7c1.svg";